export default dataNetworkHealth = {
    testingDownloadSpeed: false,
    downloadSpeed: 'N/A',
    networkBandwidth: 'N/A',
    networkRTT: 'N/A',
    testingPing: false,
    pingFailures: -1,

    get pingStatus() {
        if (this.pingFailures === -1) {
            return 'N/A';
        } else if (this.pingFailures > 0) {
            return `Failed - ${this.pingFailures} times`;
        } else {
            return 'Stable';
        }
    },

    init() {
        if ('connection' in navigator) {
            const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
            this.networkBandwidth = connection.downlink ? (connection.downlink).toFixed(2) + ' Mbps' : 'N/A';
            this.networkRTT = connection.rtt ? connection.rtt + ' ms' : 'N/A';
        }
    },

    async testDownloadSpeed() {
        this.testingDownloadSpeed = true;
        const fileUrl = '/assets/speed.7z';
        const fileSizeInBytes = 1_027_872;

        const startTime = performance.now();

        try {
            const response = await fetch(fileUrl, { cache: 'no-cache' });
            if (!response.ok) {
                this.downloadSpeed = 'Unable to test download speed';
                return;
            }
            _ = await response.blob();

            const endTime = performance.now();
            const durationInSeconds = (endTime - startTime) / 1000;

            const bitsLoaded = fileSizeInBytes * 8;
            const speedBps = bitsLoaded / durationInSeconds;
            const speedMbps = speedBps / (1024 * 1024);

            this.downloadSpeed = speedMbps.toFixed(2) + ' Mbps';
        } catch (err) {
            console.error('Speed test failed:', err);
            this.downloadSpeed = 'Unable to test download speed';
        } finally {
            this.testingDownloadSpeed = false;
        }
    },

    async testNetworkStability(repeat = 20) {
        try {
            this.testingPing = true;
            const results = [];

            for (let i = 0; i < repeat; i++) {
                const start = performance.now();

                try {
                    const response = await fetch('/ping', { cache: 'no-cache' });
                    if (!response.ok) {
                        results.push(null);
                        continue;
                    }

                    const duration = performance.now() - start;
                    results.push(duration);
                } catch (e) {
                    results.push(null);
                }

                await new Promise(resolve => setTimeout(resolve, 1000));
            }
            this.pingFailures = results.filter(r => r === null).length;
        } finally {
            this.testingPing = false;
        }
    },
}